import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function FaqSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Funciona si tengo ansiedad severa o diagnosticada?',
    answer: 'NEURO RESET Somático es un kit de herramientas de bienestar, no un tratamiento médico. Si tienes un diagnóstico clínico, estas técnicas son complementarias a tu tratamiento — no sustitutas. Muchos profesionales de salud mental recomiendan activamente estas mismas herramientas como apoyo. Consulta siempre con tu profesional de referencia.'
  }, {
    question: '¿Cuánto tiempo hasta ver resultados?',
    answer: 'Muchas personas sienten diferencia en la primera o segunda noche con el Audio SOS y las rutinas básicas. Los cambios profundos — menos ansiedad basal, sueño consistentemente mejor — suelen aparecer entre los días 7 y 14 de práctica regular. Los audios de Neuro-Hipnosis muestran resultados acumulativos más pronunciados a partir de la segunda semana.'
  }, {
    question: '¿Necesito experiencia previa con meditación o mindfulness?',
    answer: 'No. De hecho, este kit está diseñado específicamente para personas a quienes la meditación tradicional no les funciona. Las herramientas son somáticas y prácticas — actúan sobre el cuerpo, no requieren "vaciar la mente".'
  }, {
    question: '¿Cuánto tiempo requiere al día?',
    answer: 'El protocolo completo son 15 minutos diarios (5 por la mañana, 10 por la noche). El Audio SOS de emergencia son menos de 3 minutos. Las sesiones de Neuro-Hipnosis se escuchan mientras te duermes — no requieren tiempo adicional.'
  }, {
    question: '¿Puedo usarlo si tengo muy poco tiempo o mucha carga mental?',
    answer: 'Especialmente si tienes poco tiempo. Cada herramienta tiene una versión mínima de emergencia. El principio central del kit es que algo siempre es mejor que nada — y que la constancia imperfecta gana siempre sobre la perfección ocasional.'
  }];
  return <section ref={ref} className="w-full px-6 py-10 bg-warm-cream/5" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-71">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-72">
            Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-73">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-dark-navy border border-warm-cream/10 rounded-lg overflow-hidden" data-id="element-74">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-warm-cream/5 transition-colors" data-id="element-75">
                  <span className="font-semibold text-lg pr-4" data-id="element-76">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-77">
                    <ChevronDown className="w-6 h-6 text-amber-gold flex-shrink-0" data-id="element-78" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-79">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-80">
                      <div className="px-6 pb-5 text-warm-cream/80" data-id="element-81">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>

          <CtaButton text="Sí — quiero mi NEURO RESET Somático + los dos bonos" subtitle="Acceso inmediato. Sin esperas. Empieza esta noche." data-id="element-82" />
        </motion.div>
      </div>
    </section>;
}